import { render, staticRenderFns } from "./Pursh.vue?vue&type=template&id=67207350&"
import script from "./Pursh.vue?vue&type=script&lang=js&"
export * from "./Pursh.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports